import shortuuid from "short-uuid";

export function generateShortUuid(): string {
	return shortuuid(shortuuid.constants.uuid25Base36).generate();
}

export function convertShortUuidToUuid(shortUuid: string): string {
	return shortuuid(shortuuid.constants.uuid25Base36).toUUID(shortUuid);
}

export function convertUuidToShortUuid(uuid: string): string {
	return shortuuid(shortuuid.constants.uuid25Base36).fromUUID(uuid);
}

export const createCollabBranchName = (branch: string) => {
	return `collab/${branch}`;
};

export const pageAuthorityId = (
	workspaceSlug: string,
	documentId: string,
	_branch: string,
	pageId: string,
	sha: string
) => {
	const branch = _branch.replace("collab/", "");
	return `page/${workspaceSlug}/${documentId}/${pageId}@${branch}@${sha}`;
};

export const collabRegistryId = (workspaceSlug: string) => {
	return `workspace-collab-registry/${workspaceSlug}`;
};

// Note that workspaceId can either start with github| or wk- (or moment to avoid a migration.)
export interface ParsedDocumentCollabRegistryId {
	workspaceId: string;
}

export const parseDocumentCollabRegistryId = (
	id: string
): ParsedDocumentCollabRegistryId | undefined => {
	const [, workspaceId] = id.split("/");
	if (workspaceId === undefined) {
		return undefined;
	}

	if (workspaceId === "undefined") {
		return undefined;
	}

	return { workspaceId };
};

export const storeId = (workspaceSlug: string, documentId: string, _branch: string) => {
	const branch = _branch.replace("collab/", "");
	return `doc/${workspaceSlug}/${documentId}@${branch}`;
};

export const metadataStoreId = (
	workplaceSlug: string,
	documentId: string,
	_branch: string,
	sha: string
) => {
	const branch = _branch.replace("collab/", "");
	return `doc-metadata/${workplaceSlug}/${documentId}@${branch}@${sha}`;
};

export const presenceStoreId = (
	workspaceSlug: string,
	documentId: string,
	_branch: string,
	pageId: string,
	sha: string
) => {
	const branch = _branch.replace("collab/", "");
	return `page-presence/${workspaceSlug}/${documentId}/${pageId}@${branch}@${sha}`;
};

export const requestPageStoreId = (
	workspaceSlug: string,
	documentId: string,
	_branch: string,
	pageId: string,
	sha: string
) => {
	const branch = _branch.replace("collab/", "");
	return `request-page/${workspaceSlug}/${documentId}/${pageId}@${branch}@${sha}`;
};

export const documentStoreV2Id = (
	workspaceSlug: string,
	documentId: string,
	_branch: string,
	sha: string
) => {
	const branch = _branch.replace("collab/", "");
	return `doc-store-v2/${workspaceSlug}/${documentId}@${branch}@${sha}`;
};

export const isMetadataStoreId = (id: string): boolean => {
	if (id === undefined) {
		return false;
	}
	return id.startsWith("doc-metadata/");
};

export const isRequestPageStoreId = (id: string): boolean => {
	if (id === undefined) {
		return false;
	}
	return id.startsWith("request-page/");
};

export const tldrawRoomId = (
	workspaceSlug: string,
	documentId: string,
	pageId: string,
	_branch: string,
	sha: string
): string => {
	const branch = _branch.replace("collab/", "");
	const encodedPageRoomSlug = encodeURIComponent(`${pageId}@${branch}@${sha}`);
	return `${workspaceSlug}/${documentId}/${encodedPageRoomSlug}`;
};
